import { ConfigProperties } from "./interfaces/customTypes/configProperties";

const defaultConfigProperties: ConfigProperties = {
  iOSUrl: "https://apps.apple.com/us/app/",
  androidUrl: "https://play.google.com/store/",
  post: {
    twitter_max_length: 4000,
    linkedin_max_length: 4000,
    instagram_max_length: 2200,
    facebook_max_length: 49999,
    tiktok_max_length: 2200,
  },
  dashboardYoutubeId: "D7IQS4kS8_8",
  firebase: {
    api_key: "",
    auth_domain: "socialcoach-prod-d87a5.firebaseapp.com",
    data_base_url: "https://socialcoach-prod-d87a5.firebaseio.com",
    project_id: "socialcoach-prod-d87a5",
    storage_bucket: "socialcoach-prod-d87a5.appspot.com",
    messaging_sender_id: "956615638261",
    app_id: "1:956615638261:web:d2f9f6f968126d28cd99bc",
    measurement_id: "G-N9WFB7MCPR",
    baseImagesFolder: "local",
  },
  questions: [
    {
      answerType: "integer",
      content: "First, can you tell me how many transactions did you close last year?",
      contentDescriptor: "Number of transactions you closed last year",
      key: "transactionsClosedLastYear",
    },
    {
      answerType: "float",
      content: "What is your average income?",
      contentDescriptor: "Amount you make on each transaction",
      key: "averageIncomesPerTransaction",
    },
    {
      answerType: "integer",
      content: "How many leads you need in order to close a transaction?",
      contentDescriptor: "Number of leads you need in order to close a transaction",
      key: "leadsNeedToCloseTransaction",
    },
  ],
  questionsLimits: {
    transactionsClosedLastYear: 9999999,
    averageIncomesPerTransaction: 9999999,
    leadsNeedToCloseTransaction: 9999999,
  },
  stripe: {
    public_key:
      "pk_test_51H5xakEtwZQUYICbYIE0Hy9UVuqwvnzM5epz0WLARHHIGtMwWo7XhMR61JPCDqIlCDfFv3QyGN7jJ9QQAN7P9H8Z003yizy4cp",
  },
  deployBaseUrl: "https://dev.socialcoach.io/",
  defaultComplianceDisclaimer: "Example disclaimer…",
  slugBaseUrl: "https://dev.myoc.io/",
  randomPrompts: {
    minimumDaysconfigurable: 1,
    defaultDeliveryTime: "08:00AM",
    minActivePrompts: 3,
    welcomePromptRequired: false,
  },
  coachFacebookScopes: "email",
  playerFacebookScopes:
    "public_profile,email,pages_manage_posts,pages_show_list,pages_read_engagement,business_management,read_insights",
  promptMaxLength: 63206,
  trialDays: 14,
  keywordMaxLength: 100,
  googleAnalyticsId: "G-68MJL9X8MC",
  captchaSiteKey: "6LebivkZAAAAADxqtDhZHJWgM7A_qZ3tYKfVvy-Y",
};

export default defaultConfigProperties;
